import router from '@/router';
import { getOpenSplitUserTemplateProperties } from '@/functions/pages/split_user_template';

const getSplitUserTemplateWindowNameList = () => {
  return JSON.parse(window.localStorage.getItem('splitUserTemplateWindowNameList'));
};

const setSplitUserTemplateWindowNameList = list => {
  window.localStorage.setItem('splitUserTemplateWindowNameList', JSON.stringify(list));
};

export const userTemplate = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    editUserTemplateId: ''
  },
  getters: {
    editUserTemplateId: state => state.editUserTemplateId
  },
  mutations: {
    setEditUserTemplateId(state, userTemplateId) {
      state.editUserTemplateId = userTemplateId;
    },
    pushWindowName(state, payload) {
      let list = getSplitUserTemplateWindowNameList();
      if (!list) {
        list = [payload.windowName];
      } else {
        list.push(payload.windowName);
      }
      setSplitUserTemplateWindowNameList(list);
    },
    clear(state) {
      state.editUserTemplateId = '';
    },
    clearWindowNameList() {
      setSplitUserTemplateWindowNameList([]);
    },
    removeWindowName(state, payload) {
      let list = getSplitUserTemplateWindowNameList();
      if (!list) {
        list = [];
      } else {
        const index = list.indexOf(payload.windowName);
        list.splice(index, 1);
      }
      setSplitUserTemplateWindowNameList(list);
    }
  },
  actions: {
    setEditUserTemplateId(context, userTemplateId) {
      context.commit('setEditUserTemplateId', userTemplateId);
    },
    clear(context) {
      context.commit('clear');
    },
    openSplitUserTemplateWindow({ commit, dispatch }, userTemplateHeadId) {
      const routeData = router.resolve({
        name: 'SplitUserTemplate',
        query: {
          userTemplateHeadId: userTemplateHeadId
        }
      });
      commit('pushWindowName', { windowName: userTemplateHeadId });
      window.open(routeData.href, userTemplateHeadId, getOpenSplitUserTemplateProperties());
      window.CallParentfunction = function() {
        dispatch('userSettings/setUserDialogSettings', null, { root: true });
      };
    },
    destroy({ commit }) {
      const list = getSplitUserTemplateWindowNameList();
      list &&
        Array.isArray(list) &&
        list
          .filter((value, index, self) => {
            return self.indexOf(value) === index;
          })
          .forEach(windowName => {
            setTimeout(() => {
              window.open('', windowName, true).close();
            }, 1);
          });
      commit('clearWindowNameList');
    },
    destroyCurrentPage({ commit }, userTemplateHeadId) {
      window.close();
      commit('removeWindowName', { windowName: userTemplateHeadId });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user_template.js